import React from 'react';
import { Info } from 'lucide-react';
import { Card, CardContent } from './ui/card';

/**
 * Consistent info/notification box used across the site.
 * Blue background with blue text, standardized sizing for readability.
 *
 * @param {string} children - Text content (used when not pulling from settings)
 * @param {string} text - Text content from site settings
 * @param {string} className - Additional classes
 */
const InfoBox = ({ children, text, className = '' }) => {
  const content = text || children;
  if (!content) return null;

  return (
    <Card className={`border-blue-100 bg-blue-50 ${className}`} data-testid="info-box">
      <CardContent className="py-4">
        <div className="flex gap-3">
          <Info className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
          <div className="text-base text-blue-700 leading-relaxed" dangerouslySetInnerHTML={text ? { __html: text.replace(/\n/g, '<br/>') } : undefined}>
            {!text ? children : undefined}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default InfoBox;
